import React, { useState, useEffect } from 'react';
//import Card from 'react-bootstrap/Card';
import { format } from 'date-fns';

import Card from './Card';

import "./Products.scss";
import { ProductImage } from '../ProductImage/ProductImage';
import CardSkeleton from '../../../../components/common/CardSkeleton';
import { SubscriptionBillingMsg, TokenQtyMsg } from '../../../../features/Products';

export const Products = (props) => {
    let services = props.services || false;

    const [price, setPrice] = useState(null);
    const [subItem, setSubItem]=useState(null);
    const [item, setItem]=useState(props.item);
    const today = new Date();

    useEffect(() => {
        if (props.price){
            if (Array.isArray(props.price)){
                //setPrice("$"+ (Math.min( ...props.price )).toFixed(2)+" - $"+ (Math.max( ...props.price )).toFixed(2));
                setPrice(`Starting from $${Math.min(...props.price).toFixed(2)}`);
            }
            else if(!isNaN(parseInt(props.price))){
                setPrice("$"+ (+props.price).toFixed(2));
            }
            else {
                setPrice(props.price);
            } 
        }
    },[props.price]);

    useEffect(()=>{
        let _item = props.item;
        if(props.item.product_status_id === 1){
            //if there are more than one variant, it will be shown after clicking on the variant picker.  
            if(props?.item?.product_variants?.length === 1){
                setSubItem(props.item.product_variants[0]);
            } else {
                setSubItem(props.item);
            }
        }
        if (props.events) _item.events = props.events;
        setItem(_item)
    },[props.item, props.events]);

    let variant = props.item;
    if (props?.item?.product_variants?.length === 1) variant = props.item.product_variants[0];

    // if(props.loading) return <CardSkeleton columns={1} rows={1} />; //I think visually they're too distracting to see cards instead.  An indication of loading is good, but this it soo much for the pos

    return (
        <Card 
            title={props.name}
            onClick={()=>props.click(item, props.type)}
            styles={`${services ? 'services' : ''} ${Array.isArray(props.price)?"":"single"}`}
            className="pos-product-card"
        >
            {price &&
                <div className="price" data-cy="product-price">{price} {props.isActivationFee && <span className="subscription-text">activation Fee</span>}</div>
            }
            {subItem && subItem?.hasOwnProperty("bill_interval") && subItem?.hasOwnProperty("interval_quantity") &&
                <div className="subscription-text">
                    <SubscriptionBillingMsg item={subItem} />
                </div>
            }
            {props.item && props.item?.hasOwnProperty("bundled_products") &&
                <div className="subscription-text">
                    <TokenQtyMsg item={item} type="sentence" />
                </div>
            }
            {item?.events?.length > 0 &&
                <div className="subscription-text">
                    <p>
                        {item?.events[0].start_datetime && format(new Date(item?.events[0].start_datetime), "MM/dd/yyyy")} - 
                        {item?.events[0].end_datetime && format(new Date(item?.events[0].end_datetime), "MM/dd/yyyy")}
                    </p>
                    {today < new Date(item?.events[0].start_datetime) &&
                        <p className="error-text">Upcoming Event</p>
                    }
                    {today > new Date(item?.events[0].end_datetime) &&
                        <p className="error-text">Expired Event</p>
                    }
                </div>
            }
            {item?.product_status_id === 3 &&
                <div className="subscription-text">
                    This product is not publicly available
                </div>
            }
            {props.image && !services && props.cardImages &&
                <ProductImage 
                    imgSrc={props.image}
                    shape="circle"
                    aligment="center"
                    zoomEnabled={false}
                />
            
            }
            {props.description && !services &&
                <p className="product-description" data-cy="product-card-description">{props.description}</p>
            }
        </Card>
    );
}